import { createFileRoute } from "@tanstack/react-router";
import { OrganisationSettingsLayout } from "../../../pages/organisation-page/organisation-settings-layout";

export const Route = createFileRoute("/_auth/_organisation/organisation")({
  component: OrganisationSettingsLayout,
});
